import { AxiosPromise } from 'axios';
import { client }       from '@/service/client';

export function getRateCheckerTable(): AxiosPromise {
  return client.post('/rate-checker/table');
}
